import { render, staticRenderFns } from "./UnitExperiencePage.vue?vue&type=template&id=985c55fc&scoped=true"
import script from "./UnitExperiencePage.vue?vue&type=script&lang=js"
export * from "./UnitExperiencePage.vue?vue&type=script&lang=js"
import style0 from "./UnitExperiencePage.vue?vue&type=style&index=0&id=985c55fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985c55fc",
  null
  
)

export default component.exports